export const DEFAULT_IMAGE_HEIGHT_IN_PERCENTS = 60.7;
export const imageFileTypes = ['jpeg', 'jpg', 'png', 'gif', 'bmp'];

const MAX_BYTES_NUMBER = 1024;
const BYTE = 1;
const KB = MAX_BYTES_NUMBER * BYTE;
const MB = MAX_BYTES_NUMBER * KB;
const GB = MAX_BYTES_NUMBER * MB;
const TB = MAX_BYTES_NUMBER * GB;

export const FILE_SIZES = { KB, MB, GB, TB };

export const ONE_HUNDRED = 100;
export const TEN = 10;
export const TWO = 2;
export const LINE_WIDTH = 2;

export const EULA_URL = 'https://www.easygenerator.com/en/eula/';

export function getTooltipDefaultOptions() {
  return {
    defaultOffset: 5,
    defaultTemplate:
      // eslint-disable-next-line max-len
      '<div class="eg-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-contents"></div></div>',
    defaultInnerSelector: '.tooltip-contents',
    defaultHandleResize: true,
    disposeTimeout: 50,
    defaultPopperOptions: {
      modifiers: {
        computeStyle: {
          gpuAcceleration: false
        },
        preventOverflow: {
          boundariesElement: 'viewport'
        }
      }
    },
    popover: {
      defaultOffset: 5,
      defaultBaseClass: 'tooltip popover eg-popover',
      defaultInnerClass: 'popover-contents',
      defaultHandleResize: true,
      defaultPopperOptions: {
        modifiers: {
          computeStyle: {
            gpuAcceleration: false
          },
          preventOverflow: {
            boundariesElement: 'viewport'
          }
        }
      }
    }
  };
}
